// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"80ed9521","703":"83cdfc11","787":"623960b1"}[chunkId] + ".chunk.js";
};